class SearchGrantableUsers {
	constructor(
		public readonly accountId: number,
		public readonly search: string,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const params = new URLSearchParams({ search: this.search, isActive: 'true', rows: '20' });

		return params.toString();
	}
}

export default SearchGrantableUsers;
